import React, { memo } from "react";
import useMerchCard from "./index.hooks";
import { Card, Divider, Typography } from "@material-ui/core";
import { AppButton } from "components";
import { IMerchant } from "models/Merchant";
import defaultMerchantCard from "assets/images/default_merchant_card.png";

type MerchCardProps = { merchant: IMerchant };

const MerchCard = ({ merchant }: MerchCardProps) => {
  const { styles, classes, atomicStyles, t } = useMerchCard();

  return (
    <Card key={merchant.name} className={styles.merchantCard}>
      <img
        src={merchant.imageUri ? merchant.imageUri : defaultMerchantCard}
        alt={merchant.name}
        className={styles.merchLogo}
      />
      <Typography variant="h4" className={styles.merchTitle}>
        {merchant.name}
      </Typography>
      <Divider variant="fullWidth" className={styles.titleDivider} />
      <Typography className={styles.merchDescr}>
        {t(
          "Qui ci sar\u00E1 la descrizione del tuo negozio, puoi modificarla nel pannello amministrativo!",
        )}
      </Typography>
      <Divider variant="fullWidth" />
      <AppButton
        variant="contained"
        color="primary"
        path={`/merchants/${merchant._id}/events/`}
        className={styles.manageButton}
      >
        {t("Gestisci")}
      </AppButton>
    </Card>
  );
};

export default memo(MerchCard);
